import { useContext, useMemo } from 'react';

import MealPlanContext from './MealPlanContext';

/**
 * A row per plan means a client on two products has two rows, so this filters rather than
 * finds — `find` would return an arbitrary one of their products.
 */
const useClientMealPlans = (clientId) => {
  const { mealPlanAssignments } = useContext(MealPlanContext);

  return useMemo(() => (
    (mealPlanAssignments || []).filter((assignment) => assignment.userId === clientId)
  ), [
    mealPlanAssignments,
    clientId,
  ]);
};

export default useClientMealPlans;
